import React from 'react';
import { PaymentLogos } from './PaymentLogos';
export function ClosingSection() {
  return <section className="w-full py-28 md:py-36 px-4 bg-black" data-id="element-22">
      <div className="max-w-3xl mx-auto text-center space-y-8" data-id="element-23">
        <p className="font-['Playfair_Display'] font-bold text-2xl md:text-4xl text-zinc-200 leading-relaxed" data-id="element-24">
          La historia de Marset no terminó con su captura.
        </p>
        <p className="font-['Playfair_Display'] font-bold text-2xl md:text-4xl text-[#C5A014] leading-relaxed" data-id="element-25">
          Terminó cuando alguien decidió contarla completa.
        </p>

        <div className="pt-8" data-id="element-26">
          <a href="https://templeofpages.com/checkouts/cn/hWN9tQ5DtgSWWrpyJygis6de/es-us?_r=AQABmVpcacgZYb5zSd4A0a6A2wtwNLfkCHW8pMOOTZHrBLM" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#B8860B] text-black font-['Playfair_Display'] font-bold text-lg md:text-xl px-12 py-5 hover:bg-[#C5A014] transition-all duration-300 shadow-lg hover:shadow-[0_0_40px_rgba(184,134,11,0.3)] hover:scale-105 no-underline" aria-label="Leer ahora por 10 dólares" data-id="element-27">
            LEER AHORA — 6.99 USD
          </a>
          <div className="pt-4" data-id="element-28">
            <PaymentLogos data-id="element-29" />
          </div>
        </div>
      </div>
    </section>;
}